// extracted by mini-css-extract-plugin
export default {"zoomModal":"R1-z"};